import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import {
  BiData,
  BiContextProvidedValue,
  UserNameClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import useDeviationGroupListPopup from '../../../../DeviationGroupListPopup/useDeviationGroupListPopup';
import { ResourceType } from '../../../../types/resource';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import GroupCard from '../../../../GroupCard';
import s from './Groups.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const Groups: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  const onSeeAllClick = useDeviationGroupListPopup(parentDeviation);
  const isGroupsRRLink = useFlag('groups_rr_link');

  return (
    <SidebarBlockWrapper
      deviation={parentDeviation}
      block={block}
      onSeeAllClick={onSeeAllClick}
    >
      <div className={s['grid']}>
        {block.groups?.map((group, index) => (
          <GroupCard
            key={group.userId}
            group={group}
            className={s['grid-item']}
            path={isGroupsRRLink ? 'gallery' : undefined}
            anchor={isGroupsRRLink}
            biData={BiData<UserNameClickBiEvent>({
              evid: 101,
              typeid: ResourceType.GROUP,
              itemid: group.userId,
              sectionname: BiContextProvidedValue,
              _rankIndex: index,
            })}
          />
        ))}
      </div>
    </SidebarBlockWrapper>
  );
};
Groups.displayName = 'Groups';

export default Groups;
